import "./markup-menu"
import $ from 'jquery';
global.$ = global.jQuery = $;

import svg4everybody from 'svg4everybody';
import slick from 'slick-carousel';
import 'select2';
import 'jquery-mousewheel';
import 'malihu-custom-scrollbar-plugin';

import custom from './components/custom';
import select2 from './components/select2';
import Select from './components/select';
import sliders from './components/sliders';
import Tabs from './components/tabs';
import map from './components/map';
import catalog from './components/header-catalog';


document.addEventListener("DOMContentLoaded", () => {
  svg4everybody()
  catalog()
  sliders()
  select2()
  new Tabs({
    onChange() {
      $('.product__tabs-nav, .product__tabs-for').each(function (index, el) {
        $(el).slick('refresh');
      });
    }
  })
  global.customSelect = new Select();
  custom()

  if (document.getElementById('map')) {
    map();
  }
  $('.map-holder__aside-scroll').mCustomScrollbar()
  $('.select').on('click', function clickSelect() {
    if ($('.select').hasClass('select--open')) {
      $('.select').removeClass('select--open');
      $(this).toggleClass('select--open');
    }
  });
});

$(window).on('load', function () {
  $('.preloader').addClass('hide');
})

$(window).on('load resize', function () {
  if ($(window).width() < 1200) {
    $('.header__mobile-box').append($('.lang'))
    $('.header__mobile-box').append($('.header__search'))
    $('.header__mobile-box').append($('.nav'))
    $('.header__mobile-box').append($('.header__contacts'))
    $('.header__mobile-box').append($('.header__btn--settings'))
    $('.footer__social-holder').insertAfter($('.footer__btn-list'))
  } else {
    $('.lang').insertBefore($('.header__logo'))
    $('.header').append($('.header__search'))
    $('.nav').insertAfter($('.header__logo'))
    $('.header__contacts').insertAfter($('.nav'))
    $('.header__btn--settings').insertBefore($('.header__btn--search'))
    $('.js-social-footer').insertAfter($('.footer__btn-list'))
    $('.footer__social-holder').insertBefore($('.footer__form'))
  }
})


// WEBPACK FOOTER //
// app/scripts/index.js